import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as rx from "rxjs";
import { ArticuloForm } from "./form";

const ArticuloFormRx = componentToRx(ArticuloForm);
type Entity = models.Articulo;
const resource = resources.Articulo;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value?: Entity;
}
class ArticuloEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {  };
    }
    idStr = (props: Props, state: State) => this.props.match.params.id;
    id = createSelectorRx(this.idStr , id => id =="new" ? "new" : Number.parseInt(id) );
    esNuevo = createSelectorRx(this.id, id => id  == "new");
    nuevoValue = (props: Props, state: State) => ({

    } as Entity)

    valueFromResource = createSelectorRx(this.id, this.esNuevo, (id, esNuevo) =>  (esNuevo  ? toObservable(undefined) :  observeResource(resource.get, id)) as rx.Observable<(Entity | undefined)> );
    valueFromState = (props: Props, state: State) => state.value;
    value = createSelectorRx(this.valueFromState, this.valueFromResource, this.nuevoValue, (state, resource: (Entity | undefined), nuevo) => state || resource || nuevo);


    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const id = this.id(this.props, this.state);
        const valueObs = this.value(this.props, this.state);
        const value = await nextToPromise(valueObs);
        
        const func = id == "new" ? resource.add : resource.update;
        await func(value);
        history.go("../");
    }


    render() {
        const value = this.value(this.props, this.state);
        const id = this.id(this.props, this.state);
        return <ArticuloFormRx
            value={value}
            onChange={this.onChange}
            nuevo={id == "new"}
            onGuardar={this.onGuardar} />;
    }
}

export const ArticuloEdit = withRouter(ArticuloEditComp);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/articulos/edit/edit.tsx